import { Pipe, PipeTransform } from '@angular/core';
import { Hex } from '../../utils/models/types';

@Pipe({ name: 'alphaPipe', standalone: true })
export class AlphaPipe implements PipeTransform {
  transform(color?: Hex | undefined, opacity?: number | undefined): string {
    if (color) {
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    }

    return 'transparent';
  }
}
